import React from 'react';
import { Box,MenuItem,Grid,Stack,Typography,Divider,Link,Avatar,Menu,IconButton } from "@mui/material";
import AppConfig from '../appConfig';
import { Delete } from '@mui/icons-material';

const Navbar = () => {
    
    return (
        <Box
            sx={{
                width: "100%",
                position: "sticky",
                top: 0,
                left: 0,
                zIndex: 51,
            }}
        >
            <Box
                aria-label="nav-header"
                sx={{
                    display: "flex",
                    alignItems: "center",
                    height: "70px",
                    flexGrow: 1,
                    pr: (theme) => theme.spacing(2),
                    pl: (theme) => theme.spacing(2),
                    borderBottom: "none",
                    alignContent: "center",
                    zIndex: 1000,
                    boxShadow: "0px 8px 24px rgba(19,25,32,0.08)",
                    backdropFilter: "blur(8px)",
                    background: '#021931',
                    color: "#fff",
                }}
            >
                
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div style={{ display: 'flex', justifyContent: 'start', alignItems: 'center' }}>
                        <a href={AppConfig.baseUrl} id="link">
                            <img src={'https://static.hearscore360.net/images/hearScore.png'} alt="Logo" />
                        </a>
                        <h4 className="MuiTypography-root MuiTypography-h5 MuiTypography-noWrap" style={{ color: '#fff', fontWeight: '600', fontFamily: 'Inter, sans-serif' }}>Upload Portal</h4>                        
                        <div>
                    
                    
                </div>
                    </div>
                    
                </Box>
                
            </Box>
        </Box>
    )
}

export default Navbar;